import { useCallback, useRef, useEffect } from 'react';

function usePersistFn(fn, dependencies) {
  if (dependencies === void 0) {
    dependencies = [];
  }

  var ref = useRef(function () {
    throw new Error('Cannot call an event handler while rendering.');
  });
  useEffect(function () {
    ref.current = fn;
  }, [fn].concat(dependencies));
  var persist = useCallback(function () {
    var refFn = ref.current;

    if (refFn) {
      return refFn.apply(void 0, arguments);
    }
  }, [ref]);

  if (typeof fn === 'function') {
    return persist;
  }

  return undefined;
}

export default usePersistFn;